<template>
  <div
    class="header__dropdown"
    :class="{ 'header__dropdown--open': open }"
    @mouseenter="toggle(true, 'hover')"
    @mouseleave="toggle(false, 'hover')"
  >
    <button class="header__dropdown--button" @click="toggle()" @keyup.enter="openDropDown" type="button">
      {{ title }}
    </button>
    <transition name="header__dropdown--list-toggle">
      <ul class="header__dropdown--list" v-if="open">
        <a
          class="header__dropdown--item"
          v-for="link in links"
          :key="link.title"
          :href="link.url"
          @click="toggle(false, 'nav')"
        >
          {{ link.title }}
        </a>
      </ul>
    </transition>
    <div
      class="header__dropdown--backdrop"
      v-if="!openOnHover && open"
      @click="open = false"
    />
  </div>
</template>

<script>
export default {
  name: 'nt-header-dropdown',
  props: {
    title: String,
    openOnHover: { type: Boolean, default: false },
    links: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      open: false,
    }
  },
  mounted() {
    const dropdownElement = document.querySelector('.header__dropdown')
    const observer = new MutationObserver(mutationList =>
    mutationList.filter(m => m.type === 'childList').forEach(m => {
      m.addedNodes.forEach(this.handleHTMLChange)
    }))
    observer.observe(dropdownElement, { childList: true, subtree: true })
  },
  methods: {
    toggle(value, origin = 'click') {
      if (origin === 'click' && this.openOnHover) return
      if (origin === 'hover' && !this.openOnHover) return
      this.open = value === undefined ? !this.open : value
    },
    openDropDown(value) {
      this.open = value === undefined ? !this.open : value
    },
    handleHTMLChange() {
      const languageElements = document.querySelectorAll('.header__dropdown--item')
      languageElements.forEach((element) => {
        element.addEventListener('click', () => {
          window.dataLayer.push({
            event: 'navigation',
            section: 'language',
            name: element.innerText
          })
        })
      })
    }
  },
}
</script>
